import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Note, NoteFilters } from '../models/note.model';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NoteService {
  private apiUrl = environment.apiEndpoint;

  constructor(private http: HttpClient) { }

  /**
   * Get all notes for an organization with optional filters
   * @param filters Optional filters for group, startDate, and endDate
   */
  getAllNotes(organizationId: string, filters?: NoteFilters): Observable<Note[]> {
    let url = `${this.apiUrl}/organizations/${organizationId}/clients/*/ivmr/client-notes`;
    
    const params: string[] = [];
    if (filters?.group) {
      params.push(`group=${encodeURIComponent(filters.group)}`);
    }
    if (filters?.startDate) {
      params.push(`startDate=${filters.startDate}`);
    }
    if (filters?.endDate) {
      params.push(`endDate=${filters.endDate}`);
    }
    
    if (params.length > 0) {
      url += `?${params.join('&')}`;
    }
    
    return this.http.get<Note[]>(url);
  }

  
  /**
   * Close a note by ID
   * @param noteId The ID of the note to close
   * @param organizationId The organization ID (required for the endpoint)
   */
  closeNote(noteId: string, organizationId: string): Observable<Note> {
    return this.http.post<Note>(`${this.apiUrl}/organizations/${organizationId}/clients/*/ivmr/close-note`, { 
      noteId: noteId 
    });
  }

  /**
   * Create a new note
   */
  createNote(organizationId: string, note: Partial<Note>): Observable<Note> {
    return this.http.post<Note>(`${this.apiUrl}/organizations/${organizationId}/clients/*/ivmr/client-notes`, note);
  }

  /**
   * Update an existing note
   */
  updateNote(organizationId: string, noteId: string, note: Partial<Note>): Observable<Note> {
    return this.http.put<Note>(`${this.apiUrl}/organizations/${organizationId}/clients/*/ivmr/client-notes/${noteId}`, note);
  }
}
